export default __webpack_public_path__ + "static/media/avatar.50b50a59.svg";